/**
 * Traduz mensagens comuns do Django/allauth para português.
 */
const MENSAGENS_TRADUZIDAS = {
    'This password is too common.': 'Esta senha é muito comum. Escolha uma senha mais segura.',
    'This password is entirely numeric.': 'Esta senha não pode ser apenas números.',
    'The password is too similar to the email.': 'A senha é muito parecida com o e-mail.',
    'A user is already registered with this e-mail address.': 'Este e-mail já está cadastrado.',
    "The two password fields didn't match.": 'As duas senhas não coincidem.',
};

const traduzirMensagem = (texto) => MENSAGENS_TRADUZIDAS[texto] || texto;

/**
 * Analisa o objeto de erro recebido do Axios/Backend e retorna uma mensagem amigável para o usuário.
 * @param {Object} error - O objeto de erro capturado no catch
 * @param {String} defaultMessage - Uma mensagem padrão caso não consiga identificar o erro específico
 * @returns {String} A mensagem final para ser exibida no toast/alert
 */
export const getErrorMessage = (error, defaultMessage = 'Ocorreu um erro inesperado. Tente novamente.') => {
    if (error.response && error.response.data) {
        const data = error.response.data;

        // 1. BLINDAGEM CONTRA O "ERRO GIGANTE" (HTML / Erro 500 do Django)
        // Se o servidor devolver HTML (ex: página de debug amarela do Django), 
        // ignoramos o conteúdo técnico e mostramos a mensagem de suporte.
        if (typeof data === 'string' && (data.includes('<!DOCTYPE') || data.includes('<html'))) {
            return "Erro interno do sistema. Por favor, contate o suporte.";
        }

        // 2. Erros de validação específicos (Ex: "Nome já existe")
        // O Django DRF pode retornar { "campo": ["Erro"] } ou { "detail": "Erro" } ou { "erro": "Mensagem" }
        if (typeof data === 'object') {
            if (data.erro) return traduzirMensagem(data.erro);
            if (data.detail) {
                const msg = Array.isArray(data.detail) ? data.detail[0] : data.detail;
                return traduzirMensagem(msg);
            }
            
            // Pega a primeira chave de erro (ex: 'nome', 'limite') e sua mensagem
            const keys = Object.keys(data);
            if (keys.length > 0) {
                const firstKey = keys[0];
                const errorValue = data[firstKey];
                
                // Formata: "Nome: Este campo é obrigatório" e traduz mensagens comuns
                const rawText = Array.isArray(errorValue) ? errorValue[0] : errorValue;
                const errorText = traduzirMensagem(rawText);
                
                // Capitaliza a primeira letra da chave para ficar bonito
                const fieldName = firstKey.charAt(0).toUpperCase() + firstKey.slice(1);
                
                return `${fieldName}: ${errorText}`;
            }
        }
        
        // Se for uma string simples de erro retornada pela API
        if (typeof data === 'string') {
            return traduzirMensagem(data);
        }
    }

    // Se não caiu em nenhum caso acima (ex: erro de rede, servidor fora do ar)
    return defaultMessage;
};